module.exports = __webpack_public_path__ + "img/checked-users.9d602c2a.svg";